import React, {Component} from 'react';
import './MapList.css';
import Navbar from "../Navbar/Navbar";
import {Redirect, Link} from 'react-router-dom';

export default class MapList extends Component {
    state = {
        nameArr: [],
        mapName: '',
        redirectBool: false
    };
    onMapSelect = (e) => {
        this.setState({mapName: e.target.value});
        localStorage.setItem('mapName', e.target.value);
        setTimeout(() => {
            this.setState({redirectBool: true});

        }, 100);
    };

    constructor(props) {
        super(props);
        fetch(`http://iotjokebase.herokuapp.com/maplist?uuid=${localStorage.getItem('uuid')}`).then(res => {
            res.json().then(jsnRes => {
                if (jsnRes.data !== 'No Data')
                    this.setState({nameArr: jsnRes.data});
            }).catch(jsnErr => {
                console.log('JSON Error : ' + jsnErr.message);
            });
        }).catch(err => {
            console.log('Fetch Error : ' + err.message);
        });
    }

    listMaps = () => {
        return this.state.nameArr.map((dat, key) => {
            // return(<button key={key} onClick={this.onPlotSelect} value={dat.PLOTNAME}>{dat.PLOTNAME}</button>);
            return (<tr key={key}>
                <th>{dat.MAPNAME}</th>
                <td>
                    <button className='btn btn-outline-primary' value={dat.MAPNAME} onClick={this.onMapSelect}>GO
                    </button>
                </td>
            </tr>)
        });

    };
    redirectToMap = () => {
        if (this.state.redirectBool) {
            return (<Redirect to='/map'/>);
        }
    };
    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined' || localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    componentDidMount() {
        document.title = 'Map List';
    }

    render() {
        return (<div>
            {this.redirectToLogin()}
            {this.redirectToMap()}
            <Navbar/>
            <Link className='btn btn-outline-success' to='/add-map'>Add Map</Link>
            <table className='table table-bordered'>
                <tbody>
                {this.listMaps()}
                </tbody>
            </table>
        </div>);
    }
}
